import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useInternationalization } from '../../features/i18n';
import { ButtonSecondary } from '../buttons';
import { Container } from '../container';
import { SimplePageHeader } from '../simple-page-header';

const notAllowedLabel = {
  en: 'You must login to view this content.',
  id: 'Anda harus login untuk melihat konten ini.'
}

const notVerifiedLabel = {
  en: 'You must be verified to view this content.',
  id: 'Anda harus terverifikasi untuk melihat konten ini.'
}

const verifyButtonText = {
  en: 'Verify My Account',
  id: 'Verifikasi Akun Saya'
}

const SectionNotAllowed = ({isVerification}) => {
  const { translate } = useInternationalization()
  const language = useSelector(state => state.system.language)
  const history = useHistory()
  const label = isVerification ? notVerifiedLabel[language.name] : notAllowedLabel[language.name]
  const link = isVerification ? '/dashboard/settings' : '/login'

  return (
    <Container className="py-12 lg:py-24 text-center">
      <SimplePageHeader noPadding/>
      <div className="w-full lg:w-1/3 mx-auto">
        <div className="mb-4">
          {label}
        </div>
        <ButtonSecondary onClick={() => history.push(link)}>
          {isVerification ? verifyButtonText[language.name] : translate('AUTH', 'login')}
        </ButtonSecondary>
      </div>
    </Container>
  )
}

export { SectionNotAllowed }
